import React from "react";
import "../assets/css/landingpage.css";
import vector1 from "../assets/images/landing.svg";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import TopServices from "../Components/TopServices";
import { HashLink } from "react-router-hash-link";

const slideVariant = {
  hiddenRight: {
    x: "-100vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 2,
      type: "spring",
      stiffness: 50,
    },
  },
  hiddenLeft: {
    x: "100vw",
    opacity: 0,
  },
};

const containerVariants = {
  exit: {
    x: "-100vw",
    transition: {
      ease: "easeInOut",
      duration: 1,
    },
  },
};

export const Home = () => {
  return (
    <div>
      <motion.div
        id="home"
        className="container-fluid mt-0  px-md-5 home"
        style={{ minHeight: "100vh" }}
        variants={containerVariants}
        exit="exit"
      >
        <div className="row mt-2 m-md-4 p-2 p-md-4 ">
          <motion.div
            className="col mt-3 mb-3 col-md-12 text-center "
            variants={slideVariant}
            initial="hiddenRight"
            animate="visible"
          >
            <br />
            <span id="line2">
              {" "}
              <span className="fs-3 fw-bold">Your </span> <br />{" "}
              <span id="focus" className="text-warning fw-bolder">
                one stop{" "}
              </span>{" "}
              <br /> <span className="fs-3 fw-bold">for all</span> <br />{" "}
              <span id="focus" className="text-warning fw-bolder">
                {" "}
                Financial solutions
              </span>
            </span>
            <br />

            <HashLink
              smooth
              to={"/#top-services"}
              style={{ textDecoration: "none" }}
            >
              <motion.button
                className="btn d-block btn-lg mx-auto text-white text-nowrap my-4"
                style={{ background: "#fd7e14" }}
                animate={{ scale: 1.08, boxShadow: "0 0 8px yellow" }}
                transition={{ yoyo: Infinity, delay: 2, duration: "1" }}
              >
                Our Top Services
              </motion.button>
            </HashLink>
          </motion.div>
        </div>
      </motion.div>
      <div id="top-services" style={{ marginTop: "2em" }}>
        <TopServices className="mt-5" />
      </div>
    </div>
  );
};
